import { render, staticRenderFns } from "./IsLoading.vue?vue&type=template&id=356e4ee7&scoped=true"
import script from "./IsLoading.vue?vue&type=script&lang=js"
export * from "./IsLoading.vue?vue&type=script&lang=js"
import style0 from "./IsLoading.vue?vue&type=style&index=0&id=356e4ee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356e4ee7",
  null
  
)

export default component.exports